// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"3baf30f6a3881dbf","1836":"7ecdc48656c0dabf","5735":"beb578cc985d134d"}[chunkId] + ".css";
};